// frontend/app/components/admin/AccountTypeBadge.js
//
// AIT-291: read-only "Retail" / "Institute" badge on the admin student list.
// Retail = subscription-gated; Institute = exempt, with the reason shown in
// plain words (and as a hover title on web). No badge when the server sends
// no account type (non-student roles). The panel is light-only, so the colors
// are static like the rest of it.

import React from "react";
import { StyleSheet, Text, View } from "react-native";

const REASON_LABELS = {
  internal_admin: "Internal admin",
  role: "Non-student role",
  institute_managed: "Institute-managed (bulk-created)",
  school: "School account",
  partner: "Partner member",
  parent_linked: "Parent-linked",
  unknown: "Unverified account",
};

export const exemptReasonLabel = (reason) => REASON_LABELS[reason] || "Exempt";

const AccountTypeBadge = ({ accountType, reason }) => {
  if (accountType !== "retail" && accountType !== "exempt") return null;
  const isRetail = accountType === "retail";
  const reasonLabel = isRetail ? null : exemptReasonLabel(reason);
  return (
    <View style={styles.wrap}>
      <View
        style={[styles.pill, isRetail ? styles.retail : styles.institute]}
        // `title` is the web hover tooltip; ignored on native.
        {...(reasonLabel ? { title: reasonLabel } : {})}
      >
        <Text style={[styles.pillText, isRetail ? styles.retailText : styles.instituteText]}>
          {isRetail ? "Retail" : "Institute"}
        </Text>
      </View>
      {reasonLabel ? (
        <Text numberOfLines={1} ellipsizeMode="tail" style={styles.reason}>
          {reasonLabel}
        </Text>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { marginTop: 2, alignItems: "center" },
  pill: { paddingHorizontal: 8, paddingVertical: 2, borderRadius: 10 },
  pillText: { fontSize: 11, fontWeight: "600" },
  retail: { backgroundColor: "#fef3c7" },
  retailText: { color: "#b45309" },
  institute: { backgroundColor: "#dbeafe" },
  instituteText: { color: "#1d4ed8" },
  reason: { fontSize: 10, color: "#607d8b", marginTop: 1 },
});

export default AccountTypeBadge;
